import { ReferenceContent } from "@/data/references"
import { EnneagramNumberToString } from "@/data/enneagramTypes"

export interface Content extends EnneagramNumberToString {
  title?: string
  intro?: string
  page?: string
  showIf?: string
}

export interface ContentWithRef extends Content {
  refId?: string
}

export const emotions: ReferenceContent<Content> = {
  reifarth: {
    page: "S. 47",
    1: "Zorn",
    2: "Stolz",
    3: "Ruhmsucht",
    4: "Neid",
    5: "Geiz",
    6: "Furcht",
    7: "Völlerei",
    8: "Wollust",
    9: "Trägheit",
  },
  riso_hudson: {
    page: "S. 36",
    1: "Zorn",
    2: "Stolz",
    3: "Täuschung",
    4: "Neid",
    5: "Geiz",
    6: "Angst",
    7: "Gier",
    8: "Wollust",
    9: "Trägheit",
  },
  enneallionce: {
    page: "S. 11",
    1: "Zorn",
    2: "Stolz",
    3: "Eitelkeit",
    4: "Neid",
    5: "Habsucht",
    6: "Angst",
    7: "Gier",
    8: "Wollust",
    9: "Bequemlichkeit",
  },
}

export const contents: ContentWithRef[] = [
  {
    title: "Desintegrations-Richtung (Verwicklung)",
    refId: "riso_hudson",
    page: "S. 132",
    showIf: "showArrowsDisintegration",
    1: "Methodische Einsen werden plötzlich launisch und irrational, ähnlich wie gestörte Vieren",
    2: "Zuwendungsbedürftige Zweien werden plötzlich aggressiv und herrschsüchtig, ähnlich wie gestörte Achten",
    3: "Rastlose Dreien werden plötzlich verschlossen und apathisch, ähnlich wie gestörte Neunen",
    4: "Unnahbare Vieren werden plötzlich anhänglich und aufdringlich, ähnlich wie gestörte Zweien",
    5: "Distanzierte Fünfen werden plötzlich flatterhaft und hyperaktiv, ähnlich wie gestörte Siebenen",
    6: "Pflicheifrige Sechsen werden plötzlich arrogant und rücksichtslos, ähnlich wie gestörte Dreien",
    7: "Flatterhafte Siebenen werden plötzlich zu Nörglern und Perfektionisten, ähnlich wie gestörte Einsen",
    8: "Arrogante Achten werden plötzlich ängstlich und verschlossen, ähnlich wie gestörte Fünfen",
    9: "Selbstgefällige Neunen werden plötzlich  unsicher und überängstlich, ähnlich wie gestörte Sechsen",
  },

  {
    title: "Integrations-Richtung (Entwicklung)",
    refId: "riso_hudson",
    page: "S. 136",
    showIf: "showArrowsIntegration",
    1: "Zornige Einsen werden spontaner und fröhlicher, ähnlich wie gesunde Siebenen",
    2: "Stolze, sich selbst betrügende Zweien werden gefühlsbetonter und gönnen sich mehr, ähnlich wie gesunde Vieren",
    3: "Eitle, falsche Dreien setzen sich mehr für andere ein, ähnlich wie gesunde Sechsen",
    4: "Neidische, emotional aufgewühlte Vieren werden objektiver und disziplinierter, ähnlich wie gesunde Einsen",
    5: "Distanzierte, habgierige Fünfen werden selbstbewusster und entschlussfreudiger, ähnlich wie gesunde Achten",
    6: "Pessimistische, ängstliche Sechsen werden entspannter und optimistischer, ähnlich wie gesunde Neunen",
    7: "Flatterhafte, unersättliche Siebenen werden nachdenklicher und zielgerichteter, ähnlich wie gesunde Fünfen",
    8: "Machtgierige Achten werden fürsorglicher und offenherziger, ähnlich wie gesunde Zweien",
    9: "Träge, sich selbst vernachlässigende Neunen werden energischer und interessieren sich mehr für ihre Entwicklung, ähnlich wie gesunde Dreien",
  },

  {
    title: "«Selbsthilfegruppe»",
    refId: "reifarth",
    page: "S. 20",
    1: "Anonyme Grollschieber",
    2: "Anonyme Beziehungssüchtige",
    3: "Anonyme Ruhmsüchtige",
    4: "Anonyme Emotionale",
    5: "Anonyme Anonyme",
    6: "Anonyme Zweifelsüchtige",
    7: "Anonyme Unersättliche",
    8: "Anonyme Zupacker",
    9: "Anonyme Aufschieber",
  },

  {
    title: "Grundangst",
    refId: "riso_hudson",
    page: "S. 51",
    1: "Angst, unvollkommen, unehrlich, schlecht oder böse zu sein",
    2: "Angst, keine Liebe zu verdienen",
    3: "Angst, nutzlos oder ohne innere Werte zu sein",
    4: "Angst, unbedeutend oder ohne Identität zu sein",
    5: "Angst, inkompetent, unfähig oder nutzlos zu sein",
    6: "Angst, ohne Anleitung oder Unterstützung zu sein",
    7: "Angst, ausgeschlossen zu sein oder im Schmerz zu versinken",
    8: "Angst, von anderen verletzt oder beherrscht zu werden",
    9: "Angst vor Trennung, vor Aufsplitterung",
  },

  {
    title: "Grundbedürfnis",
    refId: "riso_hudson",
    page: "S. 52",
    1: "Das Bedürfnis nach Integrität",
    2: "Das Bedürfnis nach Liebe",
    3: "Das Bedürfnis nach Anerkennung",
    4: "Das Bedürfnis nach Individualität",
    5: "Das Bedürfnis nach Kompetenz",
    6: "Das Bedürfnis nach Sicherheit",
    7: "Das Bedürfnis nach Glück",
    8: "Das Bedürfnis, sich zu schützen",
    9: "Das Bedürfnis nach Ungestörtheit",
  },

  {
    title: "Unbewusstes Kindheitsgebot",
    refId: "riso_hudson",
    page: "S. 51",
    1: "Du darfst keine Fehler machen",
    2: "Du darfst keine eigenen Bedürfnisse haben",
    3: "Du darfst keine eigenen Gefühle und keinen eigenen Willen haben",
    4: "Du darfst nicht zu perfekt oder zu glücklich sein",
    5: "Du darfst dir alles nicht zu einfach machen",
    6: "Du darfst dir nicht zu viel auf dich einbilden",
    7: "Du darfst dich nicht auf andere verlassen",
    8: "Du darfst niemandem trauen oder deine Gefühle zeigen",
    9: "Du darfst nicht immer deinen Kopf durchsetzen",
  },

  {
    title: "Verlorene Ermunterung",
    refId: "riso_hudson",
    page: "S. 54",
    1: "Du bist gut",
    2: "Du bist erwünscht",
    3: "Du wirst um deiner selbst willen geliebt",
    4: "Du verdienst Anerkennung",
    5: "Deine Bedürfnisse sind kein Problem",
    6: "Du bist sicher",
    7: "Für dich wird gesorgt",
    8: "Du wirst nicht betrogen",
    9: "Du bist wichtig",
  },

  {
    title: "Schattenseite",
    refId: "riso_hudson",
    page: "S. 52",
    1: "Nörgelei und Perfektionismus",
    2: "sich unentbehrlich vorkommen",
    3: "Fixierung auf Erfolg",
    4: "Genuss-Sucht",
    5: "Eingleisigkeit",
    6: "Uneigenständigkeit",
    7: "Realitätsverlust",
    8: "Kampflustigkeit",
    9: "Nachlässigkeit, Eigensinn",
  },

  {
    title: "Stolperstein auf dem Weg zu Spiritualität",
    refId: "riso_hudson",
    page: "S. 54",
    1: "Über sich selbst und andere abfällig urteilen",
    2: "Seine Wertvorstellungen anderen Menschen anpassen",
    3: "Anders sein wollen, als man wirklich ist",
    4: "Negative Vergleiche anstellen",
    5: "Die eigene Erfahrung überbewerten",
    6: "Von etwas außerhalb unseres Selbst abhängig werden",
    7: "In Gedanken in der Zukunft verweilen",
    8: "Alles erzwingen oder beherrschen wollen",
    9: "Den eigenen Erfahrungen gegenüber gleichgültig sein",
  },

  {
    title: "Alarmzeichen",
    intro: "Hinweise, dass wir uns vom gesunden Bereich unseres Typus weg bewegen",
    refId: "riso_hudson",
    page: "S. 121",
    1: "Die Verpflichtug zu verspüren, alles selbst in Ordnung bringen zu müssen",
    2: "Zu glauben, man müsse andere für sich einnehmen",
    3: "Auf gesellschaftliche Anerkennung aus sein",
    4: "Sich durch Einbildung an Gefühle klammern und diese intensivieren",
    5: "Sich aus der realität in Ideen und geistige Weltenflüchten",
    6: "Von einer Leitfigur abhängig werden",
    7: "Zu meinen, man könne woanders etwas Besseres finden",
    8: "Den Eindruck zu haben, man müsse Druck machen, damit sich etwas rührt",
    9: "Auf den Zuspruch anderer angewiesen sein",
  },

  {
    title: "Manipulation",
    refId: "riso_hudson",
    page: "S. 122",
    1: "Korrigiert andere - besteht auf der Allgemeingültigkeit seiner Vorstellungen",
    2: "Forscht nach den Bedürfnissen anderer - um Abhängigkeiten zu schaffen",
    3: "Schmeichelt - eignet sich jedes Image an, das 'funktioniert'",
    4: "Verhält sich wie eine Mimose - erzwingt damit Rücksichtnahme",
    5: "Gibt sich gedankenverloren - hält emotional zu anderen Abstand",
    6: "Beschwert sich - testet die ihm entgegengebrachte Loyalität",
    7: "Lenkt andere ab - besteht auf Erfüllung seiner Wünsche",
    8: "Dominiert andere - fordert die Befolgung seiner Anweisungen",
    9: "Entzieht sich - leistet passiv-aggressiven Widerstand",
  },
]
